import CampaignAPI from "./campaign.api";

export function getOrganizationCampaigns({ organizationId, filters }) {
  return CampaignAPI.getOrganizationCampaigns({ organizationId, filters });
}
export function getOrganizationCampaignsServices(organizationId) {
  return CampaignAPI.getOrganizationCampaingnServices(organizationId);
}
export function postRelaunchInvitationRecordDisagreedFromCampaign({
  organizationId,
  courseId,
  recordId,
  payload,
  campaignId,
}) {
  return CampaignAPI.postRelaunchInvitationRecordDisagreedFromCampaign({
    organizationId,
    courseId,
    recordId,
    payload,
    campaignId,
  });
}
export function postCreateCopyCampaignAnonymousLink({
  organizationId,
  recordId,
  campaignId,
  settings,
}) {
  return CampaignAPI.postCreateCopyCampaignAnonymousLink({
    organizationId,
    recordId,
    campaignId,
    settings,
  });
}
export function postRelaunchInvitationRecordInProgressFromCampaign({
  organizationId,
  recordId,
  payload,
  campaignId,
}) {
  return CampaignAPI.postRelaunchInvitationRecordInProgressFromCampaign({
    organizationId,
    recordId,
    payload,
    campaignId,
  });
}
export function postOrganizationCampaign({ organizationId, payload }) {
  return CampaignAPI.postOrganizationCampaign({
    organizationId,
    payload,
  });
}
